// lib/island/recents.ts
// Zuletzt aus der Command-Palette geöffnete Einträge — localStorage-backed.

export interface RecentEntry {
  id: string;
  kind: string;
  type: string;
  label: string;
  sub?: string;
  href?: string;
  externalUrl?: string;
}

export const MAX_RECENTS = 6;
const KEY = 'island.recents';

export function readRecents(): RecentEntry[] {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed.filter(
      (e): e is RecentEntry =>
        e &&
        typeof e.id === 'string' &&
        typeof e.kind === 'string' &&
        typeof e.type === 'string' &&
        typeof e.label === 'string',
    );
  } catch {
    return [];
  }
}

export function pushRecent(entry: RecentEntry): void {
  try {
    const existing = readRecents().filter((e) => e.id !== entry.id);
    const next = [entry, ...existing].slice(0, MAX_RECENTS);
    localStorage.setItem(KEY, JSON.stringify(next));
  } catch {
    /* localStorage nicht verfügbar (SSR/Quota) — ignorieren */
  }
}
